import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateChargePointOcppConfigurationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/update-charge-point-ocpp-configuration.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateChargePointOcppConfigurationContext } from '../../charge-point.context';
import { ChargePointOcppConfigurationUpdateFormStep1Controller } from '../charge-point-ocpp-configuration-update-form-step-1/charge-point-ocpp-configuration-update-form-step-1.controller';
import { ReadonlyFormWrapperComponent } from '../charge-point-ocpp-configuration-update-form-step-1/readonly-form-wrapper.component';

export interface ChargePointOcppConfigurationUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    UpdateChargePointOcppConfigurationModel & { chargePointId: string }
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    UpdateChargePointOcppConfigurationModel & { chargePointId: string }
  >;
  onCancel: () => void;
  isReadonly: boolean;
  state: MultiStepFormState;
}

export const ChargePointOcppConfigurationUpdateFormController = (
  props: ChargePointOcppConfigurationUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, isReadonly, state } = props;
  const data = useUpdateChargePointOcppConfigurationContext();

  if (isReadonly) {
    return (
      <ReadonlyFormWrapperComponent data={data}>
        <ChargePointOcppConfigurationUpdateFormStep1Controller isReadonly />
      </ReadonlyFormWrapperComponent>
    );
  }

  return (
    <MultiStepFormProvider<
      UpdateChargePointOcppConfigurationModel & { chargePointId: string }
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['configurations'],
          component: (
            <ChargePointOcppConfigurationUpdateFormStep1Controller
              isReadonly={false}
            />
          ),
        },
      ]}
    />
  );
};
